/**
 * product-meta-line.js
 *
 * Updates SKU and inventory state in .product-meta-line when the user
 * switches variants on the product page.
 *
 * The theme dispatches a "variant:change" event on the <form> element
 * (bubbles: true) with event.detail.variant.
 *
 * Careful: that variant object does NOT contain inventory_quantity or
 * inventory_policy (verified against the rendered script[data-variant] JSON).
 * The low-stock state therefore cannot be derived here - product-meta-line.liquid
 * precomputes the affected variant IDs into data-low-stock-ids, same as it
 * already does for coming-soon variants.
 *
 * We find the .product-meta-line by walking up to the closest <safe-sticky>
 * container (which wraps the entire product-info block including the form).
 */

document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant) return;

  // Walk up from the form to find the product-info wrapper
  const container = event.target.closest('safe-sticky');
  if (!container) return;

  const metaLine = container.querySelector('.product-meta-line');
  if (!metaLine) return;

  updateSku(metaLine, variant);
  updateEan(metaLine, variant);
  updateInventory(metaLine, variant);
});

function updateSku(metaLine, variant) {
  const skuItem = metaLine.querySelector('[data-sku-item]');
  if (!skuItem) return;

  if (variant.sku) {
    const skuValue = skuItem.querySelector('[data-sku-value]');
    if (skuValue) skuValue.textContent = variant.sku;
    skuItem.hidden = false;
  } else {
    skuItem.hidden = true;
  }
}

// NZG: EAN aus variant.barcode, ohne Wert versteckt (snippets/product-meta-line.liquid)
function updateEan(metaLine, variant) {
  const eanItem = metaLine.querySelector('[data-ean-item]');
  if (!eanItem) return;

  if (variant.barcode) {
    const eanValue = eanItem.querySelector('[data-ean-value]');
    if (eanValue) eanValue.textContent = variant.barcode;
    eanItem.hidden = false;
  } else {
    eanItem.hidden = true;
  }
}

function updateInventory(metaLine, variant) {
  const invItem = metaLine.querySelector('.product-meta-line__item--inventory');
  if (!invItem) return;

  const comingSoonIds = idList(metaLine.dataset.comingSoonIds);
  const lowStockIds = idList(metaLine.dataset.lowStockIds);

  let state;
  if (comingSoonIds.includes(variant.id)) {
    state = 'coming_soon';
  } else if (!variant.available) {
    state = 'out_of_stock';
  } else if (lowStockIds.includes(variant.id)) {
    state = 'low_stock';
  } else {
    state = 'in_stock';
  }

  // Update CSS classes
  invItem.className = [
    'product-meta-line__item',
    'product-meta-line__item--inventory',
    `product-meta-line__item--${state.replaceAll('_', '-')}`,
  ].join(' ');

  // Update text using translated strings embedded in data attributes
  const texts = {
    in_stock:    invItem.dataset.textInStock,
    low_stock:   invItem.dataset.textLowStock,
    out_of_stock: invItem.dataset.textOutOfStock,
    coming_soon: invItem.dataset.textComingSoon,
  };
  invItem.textContent = texts[state] ?? '';
}

function idList(value) {
  return (value ?? '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(Number);
}
